export default {
  email: /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
};


// WEBPACK FOOTER //
// ./src/common/constants/validationConst.js